import { render } from "./ImportPlayerToFreebet.vue?vue&type=template&id=362b3804"
import script from "./ImportPlayerToFreebet.vue?vue&type=script&lang=js"
export * from "./ImportPlayerToFreebet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__